export const DEVICE_OFFLINE_THRESHOLD_MINUTES = 1440;
export const DEVICE_OUTDATED_THRESHOLD_MS = 48 * 60 * 60 * 1000;

export function isDeviceOnlineByTime(
  timeUpdated,
  thresholdMinutes = DEVICE_OFFLINE_THRESHOLD_MINUTES
) {
  if (!timeUpdated) return false;

  const updatedAtMs = new Date(timeUpdated).getTime();
  if (Number.isNaN(updatedAtMs)) return false;

  return Date.now() - updatedAtMs <= thresholdMinutes * 60 * 1000;
}

export function isDeviceOutdatedByTime(
  timeUpdated,
  thresholdMs = DEVICE_OUTDATED_THRESHOLD_MS
) {
  if (!timeUpdated) return false;

  const updatedAtMs = new Date(timeUpdated).getTime();
  if (Number.isNaN(updatedAtMs)) return false;

  return Date.now() - updatedAtMs > thresholdMs;
}
